import { useController, useFormContext } from 'react-hook-form'

import { FocusTarget } from '@/components/form/focus-target'
import { DatePickerInput } from '@/components/ui/date-picker-input'
import { DatePickerInputSize } from '@/components/ui/date-picker-input/date-picker-input.types'

interface DatePickerFormFieldProps {
  name: string
  label?: string
  placeholder?: string
  disabled?: boolean
  minDate?: Date
  maxDate?: Date
  withRestore?: boolean
  size?: DatePickerInputSize
}

export const DatePickerFormField = ({ name, withRestore, ...props }: DatePickerFormFieldProps) => {
  const { field, fieldState } = useController({ name })
  const { resetField } = useFormContext()

  const handleRestore = () => {
    resetField(name)
  }

  return (
    <FocusTarget fieldRef={field.ref}>
      <DatePickerInput
        {...props}
        name={name}
        value={field.value as Date | null}
        error={fieldState.error?.message}
        onChange={field.onChange}
        onRestore={withRestore ? handleRestore : undefined}
      />
    </FocusTarget>
  )
}
